/**
 * Pre-sampled reveal curve. Keeping the lookup and interpolation separate
 * makes the animation lifecycle readable and lets other reveal surfaces reuse
 * exactly the same timing without coupling to DOM/View Transition state.
 */
const EASE_LUT = [
	0, 0.04501, 0.08907, 0.13214, 0.17414, 0.21503, 0.25475, 0.29326, 0.33051, 0.36646, 0.4011, 0.43439, 0.46633, 0.49691,
	0.52613, 0.55401, 0.58056, 0.6058, 0.62976, 0.65247, 0.67398, 0.69432, 0.71353, 0.73166, 0.74876, 0.76486, 0.78003,
	0.7943, 0.80772, 0.82034, 0.83219, 0.84332, 0.85378, 0.86359, 0.87279, 0.88142, 0.88952, 0.89711, 0.90423, 0.9109, 0.91715,
	0.923, 0.92848, 0.93362, 0.93842, 0.94292, 0.94712, 0.95106, 0.95473, 0.95817, 0.96138, 0.96438, 0.96718, 0.96979, 0.97222,
	0.97449, 0.97661, 0.97857, 0.9804, 0.9821, 0.98368, 0.98514, 0.98649, 0.98775, 0.98891, 0.98998, 0.99097, 0.99188, 0.99272,
	0.99349, 0.99419, 0.99484, 0.99543, 0.99596, 0.99645, 0.99689, 0.99729, 0.99765, 0.99798, 0.99827, 0.99852, 0.99875, 0.99895,
	0.99913, 0.99929, 0.99942, 0.99954, 0.99963, 0.99972, 0.99978, 0.99984, 0.99988, 0.99992, 0.99995, 0.99997, 0.99998, 0.99999,
	1, 1, 1, 1, 1,
] as const;

export function easeThemeReveal(progress: number): number {
	if (progress <= 0) return 0;
	if (progress >= 1) return 1;
	const position = progress * 100;
	const index = Math.floor(position);
	const fraction = position - index;
	return EASE_LUT[index] + (EASE_LUT[index + 1] - EASE_LUT[index]) * fraction;
}
